import { FC, useState } from 'react';
import { FlexBox, usePagination } from '@brg/ui';
import { OpaUser } from '@brg/api';

import { IDesignerLight } from '../../../common';
import { DesignersGridNew } from '../../../components/grids';
import { Pagination } from '../../../components/pagination';
import { DesignerCardNew } from '../../../components/designerCard/designerCard';
import { NeutralLink } from 'shared/components/link/styles';
import { CreateLinkTo } from "../../../constants/linkTo";
import useQueryState from "../../../hooks/useQueryState";

export interface TeachersTabProps {
    teachers: IDesignerLight[];
    isLoading?: boolean;
    showOpa?: boolean;
    onDesignerClick?: (id: string) => void;
    isOpaCard?: boolean;
    pages?: number;
    noPagination?: boolean;
}

const showAll = false;

/**
 * Кладка с учителями
 * @param props
 * @constructor
 */
export const ContextViewTeachersTab: FC<TeachersTabProps> = (props) => {
    const { teachers, isLoading, showOpa, isOpaCard, pages = 20, noPagination, onDesignerClick } = props;
    const [opaUsers] = useState<OpaUser[]>([]);
    const [{ page: currentPage = 1 }, setQueryParams] = useQueryState();

    const handlePageChange = (page: number) => {
        setQueryParams({ page }, { replace: true })
    }
    
    return (
        <FlexBox direction="column" directionMobile="column" gy={40} width="100%">
            <DesignersGridNew isLoading={isLoading} mobileColumns={2} isOpaCard={isOpaCard}>
                {teachers.map((value) => {
                    const opaUser = opaUsers.find((opaUser) => opaUser.accountId === value.identifier);
                    return (
                        <DesignerCardNew
                            showOpa={showOpa}
                            onClick={onDesignerClick}
                            {...value}
                            key={value.identifier}
                            opaUser={opaUser}
                            isOpaCard={isOpaCard}
                            withRating

                        />
                    );
                })}
            </DesignersGridNew>
            {!noPagination && pages > 1 && <Pagination page={Number(currentPage)} pages={pages} onPageChange={handlePageChange} disableOffset isLoading={isLoading} />}
        </FlexBox>
    );
};
import { FC, useState } from 'react';
import { FlexBox, usePagination } from '@brg/ui';
import { OpaUser } from '@brg/api';

import { IDesignerLight } from '../../../common';
import { DesignersGridNew } from '../../../components/grids';
import { Pagination } from '../../../components/pagination';
import { DesignerCardNew } from '../../../components/designerCard/designerCard';
import { NeutralLink } from 'shared/components/link/styles';
import { CreateLinkTo } from "../../../constants/linkTo";
import useQueryState from "../../../hooks/useQueryState";

export interface TeachersTabProps {
    teachers: IDesignerLight[];
    isLoading?: boolean;
    showOpa?: boolean;
    onDesignerClick?: (id: string) => void;
    isOpaCard?: boolean;
    pages?: number;
    noPagination?: boolean;
}

const showAll = false;

/**
 * Кладка с учителями
 * @param props
 * @constructor
 */
export const ContextViewTeachersTab: FC<TeachersTabProps> = (props) => {
    const { teachers, isLoading, showOpa, isOpaCard, pages = 20, noPagination, onDesignerClick } = props;
    const [opaUsers] = useState<OpaUser[]>([]);
    const [{ page: currentPage = 1 }, setQueryParams] = useQueryState();

    const handlePageChange = (page: number) => {
        setQueryParams({ page }, { replace: true })
    }
    
    return (
        <FlexBox direction="column" directionMobile="column" gy={40} width="100%">
            <DesignersGridNew isLoading={isLoading} mobileColumns={2} isOpaCard={isOpaCard}>
                {teachers.map((value) => {
                    const opaUser = opaUsers.find((opaUser) => opaUser.accountId === value.identifier);
                    return (
                        <DesignerCardNew
                            showOpa={showOpa}
                            onClick={onDesignerClick}
                            {...value}
                            key={value.identifier}
                            opaUser={opaUser}
                            isOpaCard={isOpaCard}
                            withRating

                        />
                    );
                })}
            </DesignersGridNew>
            {!noPagination && pages > 1 && <Pagination page={Number(currentPage)} pages={pages} onPageChange={handlePageChange} disableOffset isLoading={isLoading} />}
        </FlexBox>
    );
};
